import { actionTypes } from '../index';
import { IFullBuyTariff } from '../tariffTransformer';

// @todo remove action and move implementation to the initialization method
export const setTariffs = (tariffs: IFullBuyTariff[]) => ({
    type: actionTypes.SET_TARIFFS,
    payload: tariffs,
});
